module.exports = __webpack_public_path__ + "static/media/hobby.cc402bb7.JPG";